/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import type React from "react";
import { Form } from "@fas/ui-core";
import { withForm } from "@fas/ui-framework";
import { CHANGE_PASSWORD_FORM } from "@fas/cpa-state-manager/redux/constants";
import { Typography, Button } from "@mui/material";
import { LockOpenOutlined } from "@mui/icons-material";
import { withState } from "@fas/cpa-cabinet-ui";
import { Helmet } from "react-helmet";
import TextField from "../TextFieldForm";
import AuthFormGrid from "../AuthFormGrid";
import { usePasswordField } from "../../hooks";
import schema from "./validation";
import { getValidation } from "../../utils";

const ChangePasswordForm = withForm(Form);
const PasswordField = withState(TextField, usePasswordField);
const typographySx = {
  mb: 4,
  textAlign: "center",
  minWidth: {
    sm: "max-content",
  },
};
const inputSx = {};
const btnSx = {
  mb: 1,
};
type Props = {
  isLoading: boolean;
  onKeyPress: (arg0: React.KeyboardEvent<any>) => unknown;
  onSave: () => unknown;
};

const ChangePassword: FC<Props> = ({ isLoading, onKeyPress, onSave }) => (
  <>
    <Helmet>
      <title>
        Change password
      </title>
    </Helmet>
    <ChangePasswordForm
      id={CHANGE_PASSWORD_FORM}
      validate={getValidation(schema)}
      onSave={onSave}
    >
      <AuthFormGrid>
        <Typography variant="gradientH1" sx={typographySx}>
          Change Password
        </Typography>
        <PasswordField
          name="password"
          label="Password"
          placeholder="Input your password"
          autoFocus
          StartIcon={<LockOpenOutlined />}
          onKeyPress={onKeyPress}
          sx={inputSx}
        />
        <PasswordField
          name="confirmation"
          label="Confirm Password"
          placeholder="Confirm your password"
          StartIcon={<LockOpenOutlined />}
          onKeyPress={onKeyPress}
          sx={inputSx}
        />
        <Button
          sx={btnSx}
          disabled={isLoading}
          data-testid="change-password-save"
          fullWidth
          variant="gradient"
          type="submit"
        >
          Change Password
        </Button>
      </AuthFormGrid>
    </ChangePasswordForm>
  </>
);

export default ChangePassword;
